const MATH_FOUNDATIONS_1_CURRICULUM = {
  overview: 'Counting, place value, addition, and subtraction for the youngest learners.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Number Sense and Counting',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Counting and Number Recognition',
          topics: [
            'Counting forward and backward to 100',
            'Number names (zero through one hundred)',
            'Writing numerals 0-100',
            'Counting objects in groups',
            'One-to-one correspondence',
            'Skip counting by 2s, 5s, and 10s',
            'Greater than, less than, equal to',
            'Number line basics',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Ordering and Comparing Numbers',
          topics: [
            'Ordering numbers from least to greatest',
            'Ordering numbers from greatest to least',
            'Using <, >, and = symbols',
            'Comparing two-digit numbers',
            'Comparing three-digit numbers',
            'Real-world comparison problems',
            'Ordinal numbers (first, second, third)',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Place Value',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Two-Digit Place Value',
          topics: [
            'Ones and tens place',
            'Grouping by tens',
            'Reading two-digit numbers',
            'Writing two-digit numbers',
            'Standard, word, and expanded form',
            'Comparing two-digit numbers using place value',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Three-Digit Place Value',
          topics: [
            'Hundreds, tens, and ones place',
            'Reading three-digit numbers',
            'Writing three-digit numbers',
            'Expanded form for three-digit numbers',
            'Comparing three-digit numbers',
            'Rounding to the nearest ten',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Addition Within 20',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Addition Strategies',
          topics: [
            'Counting on from a number',
            'Making ten to add',
            'Using the commutative property',
            'Adding zero',
            'Doubles and near-doubles',
            'Fact families for addition',
            'Memorizing single-digit addition facts',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Addition Word Problems',
          topics: [
            'Identifying addition situations',
            'Drawing pictures to represent problems',
            'Writing addition equations',
            'Solving one-step addition word problems',
            'Add-to and put-together problems',
            'Two-step addition problems',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Subtraction Within 20',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Subtraction Strategies',
          topics: [
            'Counting back',
            'Counting up to subtract',
            'Using doubles to subtract',
            'Subtracting zero',
            'Subtracting a number from itself',
            'Fact families for subtraction',
            'Relationship between addition and subtraction',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Subtraction Word Problems',
          topics: [
            'Identifying subtraction situations',
            'Take-from and compare problems',
            'Writing subtraction equations',
            'Solving one-step subtraction word problems',
            'Missing addend problems',
            'Two-step problems with addition and subtraction',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Addition Within 100',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Two-Digit Addition Without Regrouping',
          topics: [
            'Lining up place values',
            'Adding ones first, then tens',
            'Adding two-digit and one-digit numbers',
            'Adding two two-digit numbers',
            'Estimating sums by rounding',
            'Mental math strategies',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Two-Digit Addition With Regrouping',
          topics: [
            'When to regroup',
            'Carrying from ones to tens',
            'Adding two-digit numbers with regrouping',
            'Adding multiple two-digit numbers',
            'Word problems with regrouping',
            'Checking work by reversing addition',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Subtraction Within 100',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Two-Digit Subtraction Without Regrouping',
          topics: [
            'Lining up place values',
            'Subtracting ones first, then tens',
            'Subtracting a one-digit from a two-digit number',
            'Subtracting two two-digit numbers',
            'Estimating differences',
            'Mental math strategies',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Two-Digit Subtraction With Regrouping',
          topics: [
            'When to regroup (borrow)',
            'Borrowing from tens to ones',
            'Subtracting two-digit numbers with regrouping',
            'Word problems with regrouping',
            'Checking work by adding back',
            'Multi-step word problems',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Money',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Coins and Their Values',
          topics: [
            'Pennies, nickels, dimes, and quarters',
            'Identifying coins',
            'Counting collections of like coins',
            'Counting collections of mixed coins',
            'Comparing money amounts',
            'Skip counting with coins (5s, 10s, 25s)',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Dollars and Money Problems',
          topics: [
            'Dollar bills and their values',
            'Reading and writing money amounts with $ and ¢',
            'Decimal notation for money',
            'Making change',
            'Comparing prices',
            'Real-world money word problems',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Time',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Telling Time',
          topics: [
            'Hour, half hour, and quarter hour',
            'Reading analog clocks',
            'Reading digital clocks',
            'AM and PM',
            'Days of the week',
            'Months of the year',
            'Calendar basics',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Elapsed Time and Time Problems',
          topics: [
            'Time intervals',
            'Calculating elapsed time',
            'Word problems involving time',
            'Schedules and timelines',
            'Estimating time durations',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Measurement and Shapes',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Length and Measurement',
          topics: [
            'Comparing lengths (longer, shorter)',
            'Non-standard units of length',
            'Inches and centimeters',
            'Using a ruler',
            'Estimating lengths',
            'Solving length word problems',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Shapes and Geometry Introduction',
          topics: [
            'Two-dimensional shapes (circle, square, triangle, rectangle)',
            'Sides and vertices',
            'Three-dimensional shapes (cube, sphere, cylinder, cone)',
            'Faces, edges, and corners',
            'Composing and decomposing shapes',
            'Symmetry basics',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Data and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Picture Graphs and Bar Graphs',
          topics: [
            'Reading picture graphs',
            'Reading bar graphs',
            'Creating picture graphs from data',
            'Creating bar graphs from data',
            'Answering questions about data',
            'Comparing categories on graphs',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on essential foundation skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const MATH_FOUNDATIONS_2_CURRICULUM = {
  overview: 'Multiplication tables, division, and the building blocks of fractions.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Multiplication Foundations',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Understanding Multiplication',
          topics: [
            'Multiplication as repeated addition',
            'Equal groups',
            'Arrays and rows',
            'Skip counting connection to multiplication',
            'Multiplication notation',
            'Commutative property of multiplication',
            'Identity property (multiplying by 1)',
            'Zero property of multiplication',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Multiplication Tables 0-5',
          topics: [
            'Multiplication facts for 0',
            'Multiplication facts for 1',
            'Multiplication facts for 2',
            'Multiplication facts for 3',
            'Multiplication facts for 4',
            'Multiplication facts for 5',
            'Practice with mixed facts',
            'Real-world multiplication problems',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Multiplication Mastery',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Multiplication Tables 6-10',
          topics: [
            'Multiplication facts for 6',
            'Multiplication facts for 7',
            'Multiplication facts for 8',
            'Multiplication facts for 9',
            'Multiplication facts for 10',
            'Patterns in multiplication tables',
            'Strategies for memorization',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Multiplication Beyond the Tables',
          topics: [
            'Multiplication facts for 11 and 12',
            'Multiplying by multiples of 10 and 100',
            'Two-digit by one-digit multiplication',
            'Distributive property in multiplication',
            'Estimation in multiplication',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Division Foundations',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Understanding Division',
          topics: [
            'Division as sharing equally',
            'Division as repeated subtraction',
            'Division vocabulary (dividend, divisor, quotient)',
            'Division as the inverse of multiplication',
            'Division notation',
            'Fact families for multiplication and division',
            'Division by 1',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Division Within the Multiplication Tables',
          topics: [
            'Dividing by 2',
            'Dividing by 3',
            'Dividing by 4',
            'Dividing by 5',
            'Dividing by larger single digits',
            'Real-world division problems',
            'Word problems with quotients',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Division With Remainders',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Long Division Introduction',
          topics: [
            'Multi-digit division',
            'The long division algorithm',
            'Estimating quotients',
            'Checking division by multiplying',
            'Division word problems',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Division With Remainders',
          topics: [
            'When division does not give a whole number',
            'Interpreting remainders',
            'Remainder notation',
            'Word problems with remainders',
            'Deciding what to do with the remainder',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Fraction Foundations',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Introduction to Fractions',
          topics: [
            'Parts of a whole',
            'Numerator and denominator',
            'Reading fraction notation',
            'Halves, thirds, and fourths',
            'Fractions on a number line',
            'Unit fractions',
            'Fractions as parts of a group',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Equivalent Fractions',
          topics: [
            'What makes fractions equivalent',
            'Visual models of equivalent fractions',
            'Multiplying to find equivalent fractions',
            'Dividing to find equivalent fractions',
            'Simplifying fractions',
            'Fractions in simplest form',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Comparing and Ordering Fractions',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Comparing Fractions',
          topics: [
            'Fractions with the same denominator',
            'Fractions with the same numerator',
            'Using benchmark fractions (0, 1/2, 1)',
            'Comparing fractions with unlike denominators',
            'Using number lines to compare',
            'Ordering three or more fractions',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Mixed Numbers',
          topics: [
            'What is a mixed number',
            'Converting improper fractions to mixed numbers',
            'Converting mixed numbers to improper fractions',
            'Comparing mixed numbers',
            'Mixed numbers on a number line',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Adding and Subtracting Fractions',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Fractions With Like Denominators',
          topics: [
            'Adding fractions with the same denominator',
            'Subtracting fractions with the same denominator',
            'Adding and subtracting on a number line',
            'Word problems with like-denominator fractions',
            'Simplifying results',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Adding and Subtracting Mixed Numbers',
          topics: [
            'Adding mixed numbers with like denominators',
            'Subtracting mixed numbers with like denominators',
            'Regrouping when subtracting mixed numbers',
            'Word problems with mixed numbers',
            'Checking results',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Geometry and Area',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Polygons and Their Properties',
          topics: [
            'Identifying polygons',
            'Triangles, quadrilaterals, pentagons, hexagons',
            'Regular vs. irregular polygons',
            'Sides and angles of polygons',
            'Classifying quadrilaterals (square, rectangle, rhombus)',
            'Symmetry in polygons',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Perimeter and Area',
          topics: [
            'Perimeter as distance around',
            'Calculating perimeter of polygons',
            'Area as covering',
            'Counting unit squares',
            'Area of rectangles (length × width)',
            'Area of complex shapes',
            'Real-world perimeter and area problems',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Measurement and Data',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Customary Measurement',
          topics: [
            'Inches, feet, yards, and miles',
            'Converting between units',
            'Ounces, pounds, and tons',
            'Cups, pints, quarts, and gallons',
            'Measuring with a ruler',
            'Word problems with measurements',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Data and Graphs',
          topics: [
            'Bar graphs',
            'Pictographs',
            'Line plots',
            'Tally charts',
            'Reading and interpreting data',
            'Creating graphs from data',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Word Problems and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Multi-Step Word Problems',
          topics: [
            'Identifying the operations needed',
            'Drawing diagrams',
            'Writing equations',
            'Multi-step problems with the four operations',
            'Checking answers for reasonableness',
            'Real-world applications',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key foundation skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const MATH_FOUNDATIONS_3_CURRICULUM = {
  overview: 'Decimals, mixed numbers, and basic measurement built on solid arithmetic.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Place Value With Decimals',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Decimal Place Value',
          topics: [
            'Place values to the right of the decimal point',
            'Tenths and hundredths',
            'Thousandths',
            'Reading and writing decimals',
            'Standard, word, and expanded form for decimals',
            'Decimals on a number line',
            'Comparing decimals using place value',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Comparing and Rounding Decimals',
          topics: [
            'Comparing decimals to two places',
            'Comparing decimals to three places',
            'Ordering decimals',
            'Rounding decimals to the nearest whole',
            'Rounding to the nearest tenth',
            'Rounding to the nearest hundredth',
            'Estimating with decimals',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Decimal Operations',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Adding and Subtracting Decimals',
          topics: [
            'Lining up decimal points',
            'Adding decimals with the same number of places',
            'Adding decimals with different numbers of places',
            'Subtracting decimals',
            'Estimating sums and differences',
            'Word problems with decimal addition and subtraction',
            'Checking work',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Multiplying Decimals',
          topics: [
            'Multiplying a decimal by a whole number',
            'Multiplying two decimals',
            'Counting decimal places in the product',
            'Estimating products',
            'Multiplying by powers of 10',
            'Real-world multiplication problems with decimals',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Dividing Decimals',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Dividing Decimals by Whole Numbers',
          topics: [
            'Setting up the division',
            'Bringing up the decimal point',
            'Quotients with decimal parts',
            'Word problems with decimal division',
            'Estimating quotients',
            'Checking work by multiplying',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Dividing by Decimals',
          topics: [
            'Moving the decimal point in the divisor and dividend',
            'Dividing a whole number by a decimal',
            'Dividing a decimal by a decimal',
            'Real-world division problems',
            'Dividing by powers of 10',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Mixed Numbers and Improper Fractions',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Working With Mixed Numbers',
          topics: [
            'Identifying parts of a mixed number',
            'Converting improper fractions to mixed numbers',
            'Converting mixed numbers to improper fractions',
            'Adding and subtracting mixed numbers with like denominators',
            'Regrouping when needed',
            'Comparing and ordering mixed numbers',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Fractions With Unlike Denominators',
          topics: [
            'Finding a common denominator',
            'Least common denominator (LCD)',
            'Adding fractions with unlike denominators',
            'Subtracting fractions with unlike denominators',
            'Adding and subtracting mixed numbers with unlike denominators',
            'Word problems',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Multiplying and Dividing Fractions',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Multiplying Fractions',
          topics: [
            'Multiplying a fraction by a whole number',
            'Multiplying two fractions',
            'Simplifying before multiplying',
            'Multiplying mixed numbers',
            'Visual models of fraction multiplication',
            'Word problems',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Dividing Fractions',
          topics: [
            'Reciprocals',
            'Dividing a whole number by a fraction',
            'Dividing a fraction by a whole number',
            'Dividing two fractions',
            'Dividing mixed numbers',
            'Real-world fraction division problems',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Connecting Fractions and Decimals',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Converting Fractions and Decimals',
          topics: [
            'Converting fractions to decimals by dividing',
            'Terminating and repeating decimals',
            'Converting decimals to fractions',
            'Simplifying fraction results',
            'Comparing fractions and decimals',
            'Ordering fractions and decimals together',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Percent Introduction',
          topics: [
            'Percent as parts per hundred',
            'Converting fractions to percents',
            'Converting percents to fractions',
            'Converting decimals to percents',
            'Converting percents to decimals',
            'Real-world percent recognition',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Customary and Metric Measurement',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Customary Measurement Conversions',
          topics: [
            'Inches, feet, yards, and miles',
            'Converting between length units',
            'Ounces, pounds, and tons for weight',
            'Fluid ounces, cups, pints, quarts, and gallons',
            'Multi-step conversion problems',
            'Choosing appropriate units',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Metric Measurement Conversions',
          topics: [
            'Millimeters, centimeters, meters, and kilometers',
            'Milliliters and liters',
            'Milligrams, grams, and kilograms',
            'Powers of 10 in metric conversions',
            'Converting between metric units',
            'Comparing customary and metric',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Geometry Basics',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Angles and Lines',
          topics: [
            'Points, lines, line segments, and rays',
            'Parallel lines',
            'Perpendicular lines',
            'Acute, right, obtuse, and straight angles',
            'Measuring angles with a protractor',
            'Drawing angles',
            'Adjacent and complementary angles',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Classifying Shapes',
          topics: [
            'Triangles by side length (scalene, isosceles, equilateral)',
            'Triangles by angle (acute, right, obtuse)',
            'Quadrilaterals (parallelogram, rectangle, rhombus, square, trapezoid)',
            'Properties of each shape',
            'Hierarchy of quadrilaterals',
            'Polygons and regular polygons',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Area, Perimeter, and Volume',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Perimeter and Area',
          topics: [
            'Perimeter of polygons',
            'Area of rectangles',
            'Area of squares',
            'Area of triangles',
            'Area of composite shapes',
            'Word problems',
            'Real-world applications',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Volume of Rectangular Prisms',
          topics: [
            'Three-dimensional shapes (cube, rectangular prism, cylinder, cone, sphere)',
            'Volume as the amount of space inside',
            'Cubic units',
            'Volume of a cube',
            'Volume of a rectangular prism (length × width × height)',
            'Volume of composite figures',
            'Real-world volume problems',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Data and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Coordinate Plane and Data',
          topics: [
            'The coordinate plane (first quadrant)',
            'Plotting points',
            'Reading line graphs',
            'Reading double bar graphs',
            'Mean, median, and mode (introduction)',
            'Creating and interpreting data displays',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on essential foundation skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const MATH_FOUNDATIONS_4_CURRICULUM = {
  overview: 'Ratios, rates, percents, and rational numbers, the final bridge to algebra.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Introduction to Ratios',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Understanding Ratios',
          topics: [
            'Ratios as comparisons',
            'Three forms (a to b, a:b, a/b)',
            'Part-to-part vs. part-to-whole ratios',
            'Writing ratios from real-world situations',
            'Ratios with multiple comparisons',
            'Equivalent ratios',
            'Simplifying ratios',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Working With Ratio Tables',
          topics: [
            'Building ratio tables',
            'Filling in missing values',
            'Identifying equivalent ratios',
            'Using ratio tables to solve problems',
            'Graphing ratio relationships',
            'Multiplicative and additive thinking with ratios',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Rates and Unit Rates',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Rates',
          topics: [
            'Difference between ratios and rates',
            'Common rates (speed, density, price per item)',
            'Writing rates from real-world situations',
            'Comparing rates',
            'Better-buy comparisons',
            'Speed problems',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Unit Rates',
          topics: [
            'What makes a unit rate',
            'Calculating unit rates by dividing',
            'Unit price (cost per item)',
            'Unit conversion using rates',
            'Identifying the best deal',
            'Real-world unit rate problems',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Proportions',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Proportional Reasoning',
          topics: [
            'Recognizing proportional relationships',
            'Tables, equations, and graphs of proportions',
            'The constant of proportionality',
            'Direct variation y = kx',
            'Identifying proportional vs. non-proportional relationships',
            'Graphing proportional relationships',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Solving Proportions',
          topics: [
            'Setting up proportions from word problems',
            'Cross multiplication',
            'Solving proportions for an unknown',
            'Scaling up and scaling down',
            'Scale drawings and maps',
            'Similar figures and scale factor',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Percent Foundations',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Connecting Percents, Fractions, and Decimals',
          topics: [
            'Percent as a ratio out of 100',
            'Converting between fractions, decimals, and percents',
            'Percents greater than 100',
            'Percents less than 1',
            'Comparing values in different forms',
            'Estimating with benchmarks (10%, 25%, 50%)',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Calculating Percents',
          topics: [
            'Finding the percent of a number',
            'The percent equation (part = percent × whole)',
            'The percent proportion',
            'Finding the whole given a part and a percent',
            'Finding what percent one number is of another',
            'Choosing a calculation strategy',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Percent Applications',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Real-World Percents',
          topics: [
            'Sales tax',
            'Tip',
            'Discounts and sale price',
            'Markup and markdown',
            'Commission',
            'Total cost problems',
            'Multi-step percent problems',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Percent of Change',
          topics: [
            'Percent increase',
            'Percent decrease',
            'Calculating percent change',
            'Original value and new value problems',
            'Simple interest (I = Prt)',
            'Real-world percent change problems',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Introduction to Rational Numbers',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Negative Numbers and the Number Line',
          topics: [
            'Positive and negative numbers',
            'Opposites',
            'Number line with negatives',
            'Comparing positive and negative numbers',
            'Absolute value as distance from zero',
            'Real-world contexts for negatives (temperature, debt, elevation)',
            'Ordering rational numbers',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Adding and Subtracting Rational Numbers',
          topics: [
            'Adding two negatives',
            'Adding numbers with different signs',
            'Subtracting as adding the opposite',
            'Subtracting negatives',
            'Word problems with positive and negative numbers',
            'Using a number line model',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Multiplying and Dividing Rational Numbers',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Multiplying Rational Numbers',
          topics: [
            'Multiplying integers with the same sign',
            'Multiplying integers with different signs',
            'Multiplying signed fractions',
            'Multiplying signed decimals',
            'Real-world multiplication problems',
            'Patterns in signs',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Dividing Rational Numbers',
          topics: [
            'Dividing integers with the same sign',
            'Dividing integers with different signs',
            'Dividing signed fractions',
            'Dividing signed decimals',
            'Real-world division problems',
            'The rules of signs summarized',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Coordinate Plane and Rational Numbers',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'All Four Quadrants',
          topics: [
            'The four quadrants of the coordinate plane',
            'Plotting points with negative coordinates',
            'Identifying the quadrant of a point',
            'Reflecting points across the axes',
            'Distance between points (horizontal and vertical)',
            'Polygons on the coordinate plane',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Graphing Relationships',
          topics: [
            'Tables to graphs',
            'Identifying proportional relationships from graphs',
            'Identifying linear relationships',
            'Rate of change from graphs',
            'Real-world graph interpretation',
            'Independent and dependent variables',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Expressions and Equations Preview',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Algebraic Expressions',
          topics: [
            'Variables and constants',
            'Writing expressions from words',
            'Evaluating expressions',
            'Like terms',
            'Simplifying with the distributive property',
            'Combining like terms',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'One-Step Equations',
          topics: [
            'What it means to solve an equation',
            'Inverse operations',
            'One-step equations with addition and subtraction',
            'One-step equations with multiplication and division',
            'Checking solutions',
            'Word problems leading to equations',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Statistics, Probability, and Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Statistics and Probability Basics',
          topics: [
            'Mean, median, mode, and range',
            'Outliers and their effect',
            'Reading dot plots and histograms',
            'Probability of a simple event',
            'Theoretical vs. experimental probability',
            'Sample space',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on essential pre-algebra readiness skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const ARITHMETIC_MASTERY_CURRICULUM = {
  overview: 'Comprehensive arithmetic review for confident pre-algebra readiness.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Whole Numbers Comprehensive',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Whole Number Operations',
          topics: [
            'Place value review (millions and beyond)',
            'Reading and writing large numbers',
            'Comparing and ordering whole numbers',
            'Rounding to any place',
            'All four operations with whole numbers',
            'Order of operations (PEMDAS)',
            'Properties of operations',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Word Problems With Whole Numbers',
          topics: [
            'Identifying operations from context',
            'Multi-step word problems',
            'Estimating answers for reasonableness',
            'Writing equations from words',
            'Checking solutions',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Factors, Multiples, and Number Theory',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Factors and Multiples',
          topics: [
            'Finding factors of a number',
            'Identifying prime numbers',
            'Identifying composite numbers',
            'Listing multiples',
            'Common factors and multiples',
            'Divisibility rules (2, 3, 4, 5, 6, 9, 10)',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'GCF, LCM, and Prime Factorization',
          topics: [
            'Prime factorization (factor trees)',
            'Greatest common factor (GCF)',
            'Least common multiple (LCM)',
            'Using GCF and LCM in word problems',
            'Relationship between GCF and LCM',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Integers Comprehensive',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Integer Concepts',
          topics: [
            'Positive and negative numbers',
            'The number line',
            'Opposites',
            'Absolute value',
            'Comparing and ordering integers',
            'Real-world integer contexts',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Integer Operations',
          topics: [
            'Adding integers (same and different signs)',
            'Subtracting integers',
            'Multiplying integers',
            'Dividing integers',
            'Order of operations with integers',
            'Word problems with integers',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Fractions Comprehensive',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Fraction Foundations',
          topics: [
            'Equivalent fractions',
            'Simplifying fractions',
            'Comparing and ordering fractions',
            'Converting between mixed numbers and improper fractions',
            'Fractions on a number line',
            'Estimating with fractions',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Fraction Operations',
          topics: [
            'Adding and subtracting like-denominator fractions',
            'Adding and subtracting unlike-denominator fractions',
            'Multiplying fractions',
            'Dividing fractions',
            'Operations with mixed numbers',
            'Multi-step fraction word problems',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Decimals Comprehensive',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Decimal Concepts',
          topics: [
            'Decimal place value (to thousandths)',
            'Reading and writing decimals',
            'Comparing and ordering decimals',
            'Rounding decimals',
            'Decimals on a number line',
            'Estimating with decimals',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Decimal Operations',
          topics: [
            'Adding and subtracting decimals',
            'Multiplying decimals',
            'Dividing decimals (by whole numbers and by decimals)',
            'Multiplying and dividing by powers of 10',
            'Multi-step decimal word problems',
            'Converting between fractions and decimals',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Percent Comprehensive',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Percent Foundations',
          topics: [
            'Percent as a ratio out of 100',
            'Converting fractions, decimals, and percents',
            'Benchmark percents (10%, 25%, 50%, 75%)',
            'Percent of a number',
            'The percent equation',
            'The percent proportion',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Percent Applications',
          topics: [
            'Sales tax, tip, and discount',
            'Markup and markdown',
            'Percent increase and decrease',
            'Simple interest',
            'Multi-step percent problems',
            'Word problems with percents',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Ratios, Rates, and Proportions',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Ratios and Rates',
          topics: [
            'Writing ratios',
            'Equivalent ratios',
            'Ratio tables',
            'Rates and unit rates',
            'Comparing rates',
            'Best-buy comparisons',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Proportions',
          topics: [
            'Setting up proportions',
            'Cross multiplication',
            'Solving for an unknown',
            'Direct variation',
            'Scale drawings and maps',
            'Similar figures',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Exponents and Order of Operations',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Exponents',
          topics: [
            'Exponential notation',
            'Base, exponent, and power',
            'Evaluating expressions with exponents',
            'Powers of 10',
            'Perfect squares',
            'Square roots',
            'Perfect cubes and cube roots',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Order of Operations Mastery',
          topics: [
            'PEMDAS with all operations',
            'Parentheses and brackets',
            'Nested grouping symbols',
            'Order of operations with fractions and decimals',
            'Common mistakes and how to avoid them',
            'Complex multi-step expressions',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Pre-Algebra Bridge Topics',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Algebraic Thinking',
          topics: [
            'Variables as unknowns',
            'Translating words into expressions',
            'Evaluating expressions for given values',
            'Like terms',
            'Combining like terms',
            'The distributive property',
            'Simplifying expressions',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'One- and Two-Step Equations',
          topics: [
            'What it means to solve an equation',
            'Inverse operations',
            'Solving one-step equations',
            'Solving two-step equations',
            'Checking solutions',
            'Word problems leading to equations',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Problem Solving and Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Problem Solving Strategies',
          topics: [
            'Reading and understanding word problems',
            'Identifying given information and what is asked',
            'Choosing a strategy (draw a picture, make a table, work backward)',
            'Multi-step word problems',
            'Estimating and checking',
            'Real-world applications',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on essential pre-algebra readiness',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const INTRO_PRE_ALGEBRA_CURRICULUM = {
  overview: 'Variables, simple equations, and the first taste of algebraic thinking.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Number System Foundations',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Real Numbers',
          topics: [
            'Sets of numbers: natural, whole, integer, rational, irrational, real',
            'Identifying which set a number belongs to',
            'The number line',
            'Opposites and absolute value',
            'Comparing rational numbers in different forms',
            'Real-world contexts for each number type',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Operations With Rational Numbers',
          topics: [
            'Adding and subtracting rational numbers',
            'Multiplying and dividing rational numbers',
            'Order of operations with rational numbers',
            'Operations across forms (fractions, decimals, mixed)',
            'Real-world rational number problems',
            'Checking work for sign errors',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Exponents and Powers',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Exponential Notation',
          topics: [
            'Exponential form',
            'Evaluating expressions with exponents',
            'Powers of integers',
            'Powers of fractions',
            'Comparing values written with exponents',
            'Common mistakes with negatives and exponents',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Roots and Scientific Notation',
          topics: [
            'Square roots and perfect squares',
            'Cube roots and perfect cubes',
            'Estimating square roots',
            'Introduction to irrational numbers',
            'Scientific notation for large numbers',
            'Scientific notation for small numbers',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Algebraic Expressions',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Building and Simplifying Expressions',
          topics: [
            'Variables, constants, and coefficients',
            'Translating verbal phrases into algebraic expressions',
            'Distinguishing expressions from equations',
            'Evaluating expressions',
            'Like terms',
            'Combining like terms',
            'The distributive property',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Working With Expressions',
          topics: [
            'Expanding expressions with the distributive property',
            'Factoring out a common factor',
            'Simplifying complex expressions',
            'Properties of operations applied to algebra',
            'Equivalent expressions',
            'Word-to-expression translation practice',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'One-Step and Two-Step Equations',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'One-Step Equations',
          topics: [
            'What it means to solve an equation',
            'Inverse operations',
            'The balance principle',
            'One-step equations (all four operations)',
            'Checking solutions',
            'One-step word problems',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Two-Step Equations',
          topics: [
            'Strategy for two-step equations',
            'Two-step equations with addition/subtraction and multiplication/division',
            'Two-step equations with negative coefficients',
            'Two-step equations with fractions',
            'Word problems leading to two-step equations',
            'Checking solutions',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Multi-Step Equations and Inequalities',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Multi-Step Equations',
          topics: [
            'Equations with the distributive property',
            'Combining like terms first',
            'Variables on both sides',
            'Special cases (no solution, infinite solutions)',
            'Multi-step word problems',
            'Checking solutions',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Inequalities',
          topics: [
            'Inequality symbols',
            'Graphing inequalities on a number line',
            'Open and closed circles',
            'Solving one-step inequalities',
            'The flip-the-sign rule for negatives',
            'Solving two-step inequalities',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Ratios, Proportions, and Percents',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Ratios and Proportions',
          topics: [
            'Writing ratios',
            'Equivalent ratios and tables',
            'Rates and unit rates',
            'Solving proportions by cross multiplication',
            'Direct variation',
            'Word problems with proportions',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Percent Applications',
          topics: [
            'The percent equation and percent proportion',
            'Finding part, whole, or percent',
            'Sales tax, tip, and discount',
            'Markup, markdown, and commission',
            'Percent increase and decrease',
            'Simple interest',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'The Coordinate Plane and Functions',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Coordinate Plane and Relations',
          topics: [
            'The four quadrants',
            'Plotting and identifying points',
            'Tables of values',
            'Graphing ordered pairs from a table',
            'Relations as sets of ordered pairs',
            'Function vs. non-function (vertical line test)',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Linear Functions Preview',
          topics: [
            'Identifying linear relationships',
            'Slope as rate of change',
            'Calculating slope from two points',
            'y-intercept',
            'The form y = mx + b (introduction)',
            'Graphing simple linear equations',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Geometry Foundations',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Angles, Lines, and Triangles',
          topics: [
            'Angle types (acute, right, obtuse, straight)',
            'Complementary, supplementary, and vertical angles',
            'Parallel lines and transversals',
            'Triangle angle sum',
            'Classifying triangles by sides and angles',
            'The Pythagorean theorem (introduction)',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Area, Perimeter, and Volume',
          topics: [
            'Perimeter of polygons',
            'Area of rectangles, triangles, parallelograms, and trapezoids',
            'Circumference and area of a circle',
            'Volume of rectangular prisms',
            'Volume of cylinders',
            'Real-world geometry problems',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Probability and Statistics',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Probability',
          topics: [
            'Probability of a simple event',
            'Sample space',
            'Theoretical vs. experimental probability',
            'Probability of compound events',
            'Independent and dependent events',
            'Real-world probability problems',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Data and Statistics',
          topics: [
            'Mean, median, mode, and range',
            'Outliers and their effect',
            'Reading dot plots, histograms, and box plots',
            'Scatter plots and association',
            'Choosing the right measure of center',
            'Interpreting data displays',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Pre-Algebra Connections',
          topics: [
            'Connecting expressions, equations, and inequalities',
            'From words to algebra to graphs',
            'Multi-topic problem solving',
            'Bridge to full Pre-Algebra',
            'Common mistakes and how to avoid them',
            'Test-taking strategies',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key intro pre-algebra skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const PRE_ALGEBRA_CURRICULUM = {
  overview: 'Build a rock-solid foundation in arithmetic, fractions, ratios, and intro to variables.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Whole Numbers and Integers',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Whole Number Foundations',
          topics: [
            'Place value of whole numbers',
            'Reading and writing whole numbers in standard, expanded, and word form',
            'Rounding whole numbers',
            'Adding and subtracting whole numbers',
            'Multiplying whole numbers',
            'Dividing whole numbers, including remainders',
            'Order of operations (PEMDAS) with whole numbers',
            'Properties of operations: commutative, associative, identity, distributive',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Integer Operations',
          topics: [
            'Negative numbers and the number line',
            'Comparing and ordering integers',
            'Absolute value as distance from zero',
            'Adding integers with the same sign',
            'Adding integers with different signs',
            'Subtracting integers',
            'Multiplying integers',
            'Dividing integers',
            'Order of operations with integers',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Number Theory, Exponents, and Roots',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Factors, Multiples, and Primes',
          topics: [
            'Divisibility rules (2, 3, 4, 5, 6, 9, 10)',
            'Factors and multiples',
            'Prime and composite numbers',
            'Prime factorization (factor trees)',
            'Greatest Common Factor (GCF)',
            'Least Common Multiple (LCM)',
            'Using GCF and LCM in problem solving',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Exponents, Powers, and Roots',
          topics: [
            'Exponential notation: base, exponent, power',
            'Evaluating expressions with exponents',
            'Powers of 10',
            'Perfect squares',
            'Square roots',
            'Perfect cubes',
            'Cube roots',
            'Scientific notation (introduction)',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Fractions',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Fraction Foundations and Adding/Subtracting Fractions',
          topics: [
            'Fractions as parts of a whole and as division',
            'Equivalent fractions',
            'Simplifying fractions to lowest terms',
            'Comparing and ordering fractions',
            'Adding fractions with like denominators',
            'Subtracting fractions with like denominators',
            'Adding fractions with unlike denominators (using the LCD)',
            'Subtracting fractions with unlike denominators',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Multiplying/Dividing Fractions and Mixed Numbers',
          topics: [
            'Multiplying fractions',
            'Dividing fractions (multiply by the reciprocal)',
            'Converting between mixed numbers and improper fractions',
            'Adding and subtracting mixed numbers',
            'Multiplying and dividing mixed numbers',
            'Word problems involving fractions',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Decimals and Rational Numbers',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Decimal Operations',
          topics: [
            'Decimal place value',
            'Reading and writing decimals',
            'Comparing and ordering decimals',
            'Rounding decimals',
            'Adding and subtracting decimals',
            'Multiplying decimals',
            'Dividing decimals by whole numbers',
            'Dividing by a decimal divisor',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Connecting Fractions, Decimals, and Percents',
          topics: [
            'Converting fractions to decimals (terminating and repeating)',
            'Converting decimals to fractions',
            'Converting fractions to percents',
            'Converting percents to fractions',
            'Converting decimals to percents',
            'Converting percents to decimals',
            'Rational numbers',
            'Comparing and ordering rational numbers across forms',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Proportional Reasoning',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Ratios, Rates, Unit Rates, and Proportions',
          topics: [
            'Writing ratios in three forms (a to b, a:b, a/b)',
            'Equivalent ratios',
            'Ratio tables',
            'Rates (quantities with different units)',
            'Unit rates',
            'Unit pricing and best-buy comparisons',
            'Comparing rates',
            'Proportions as equations of equivalent ratios',
            'Solving proportions by cross multiplication',
            'Identifying proportional relationships from tables and equations',
            'Constant of proportionality',
            'Scale drawings and scale factors',
            'Maps and models',
            'Direct variation: y = kx',
            'Real-world ratio, rate, and proportion applications',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Percent Calculations and Applications',
          topics: [
            'Percent as a ratio out of 100',
            'Finding the percent of a number',
            'Finding the whole given a part and a percent',
            'Finding what percent one number is of another',
            'Percent equation: part = percent × whole',
            'Percent proportion',
            'Sales tax',
            'Tip',
            'Discount and sale price',
            'Markup and markdown',
            'Percent change: percent increase and percent decrease',
            'Simple interest: I = Prt',
            'Compound interest (introduction)',
            'Real-world percent problem solving',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Algebraic Foundations',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Variables, Expressions, and Properties',
          topics: [
            'Variables and constants',
            'Distinguishing expressions from equations',
            'Translating verbal phrases into algebraic expressions',
            'Evaluating expressions for given variable values',
            'Combining like terms',
            'The distributive property with variables',
            'Properties of operations (commutative, associative, identity, distributive) applied to algebraic expressions',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Solving Equations and Inequalities',
          topics: [
            'What it means to solve an equation',
            'Inverse operations',
            'Solving one-step equations (all four operations)',
            'Solving two-step equations',
            'Checking solutions',
            'Word problems leading to equations',
            'Solving one-step inequalities',
            'Graphing inequality solutions on a number line',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Coordinate Plane and Linear Relationships',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'The Coordinate Plane',
          topics: [
            'The coordinate plane: origin, axes, quadrants',
            'Plotting points in all four quadrants',
            'Identifying coordinates of points',
            'Distance between points on horizontal or vertical lines',
            'Reflecting points across the x- and y-axes',
            'Polygons on the coordinate plane',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Linear Patterns and Graphs',
          topics: [
            'Patterns and rules',
            'Tables of values from a rule',
            'Graphing ordered pairs from a table',
            'Linear relationships and constant rate of change',
            'Slope as rise over run (introduction)',
            'Identifying slope from a graph',
            'Identifying the y-intercept from a graph',
            'Graphing simple linear equations of the form y = mx + b',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Geometry I — Angles and Triangles',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Angles and Angle Relationships',
          topics: [
            'Types of angles: acute, right, obtuse, straight',
            'Measuring angles with a protractor',
            'Complementary angles',
            'Supplementary angles',
            'Vertical angles',
            'Adjacent angles',
            'Parallel lines cut by a transversal',
            'Corresponding, alternate interior, and alternate exterior angles',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Triangles and the Pythagorean Theorem',
          topics: [
            'Classifying triangles by sides: scalene, isosceles, equilateral',
            'Classifying triangles by angles: acute, right, obtuse',
            'Triangle angle sum (180°)',
            'Exterior angle theorem',
            'The Pythagorean theorem: a² + b² = c²',
            'Applying the Pythagorean theorem to find a missing side',
            'The converse of the Pythagorean theorem',
            'Real-world Pythagorean theorem applications',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Geometry II — Measurement and Transformations',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Perimeter, Circumference, and Area',
          topics: [
            'Perimeter of polygons',
            'Area of rectangles and squares',
            'Area of triangles',
            'Area of parallelograms',
            'Area of trapezoids',
            'Circumference of a circle',
            'Area of a circle',
            'Area of composite figures',
            'Real-world perimeter and area problems',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Surface Area, Volume, and Transformations',
          topics: [
            'Surface area of rectangular prisms',
            'Surface area of cylinders',
            'Volume of rectangular prisms',
            'Volume of cylinders',
            'Volume of pyramids and cones',
            'Similar figures and scale factor',
            'Congruent figures',
            'Transformations: translations',
            'Transformations: reflections',
            'Transformations: rotations',
            'Transformations: dilations',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Statistics, Probability, and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Statistics and Probability',
          topics: [
            'Mean, median, mode, and range',
            'Mean Absolute Deviation (MAD)',
            'Dot plots',
            'Histograms',
            'Box plots (box-and-whisker plots)',
            'Scatter plots and types of association',
            'Probability of a simple event',
            'Theoretical vs. experimental probability',
            'Probability of compound events',
            'Independent vs. dependent events',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on essential pre-algebra skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const ALGEBRA_1_CURRICULUM = {
  overview: 'Master linear equations, inequalities, functions, and quadratics in this comprehensive bootcamp.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Foundations',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'The Real Number System & Order of Operations',
          topics: [
            'Sets of numbers: natural, whole, integer, rational, irrational, real',
            'Nesting of number sets',
            'Absolute value as distance',
            'Operations on signed numbers',
            'Order of operations (PEMDAS)',
            'Distinguishing (−x)² from −x²',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Variables, Expressions, and the Distributive Property',
          topics: [
            'Translating verbal phrases into algebraic expressions',
            'Evaluating expressions for given variable values',
            'The distributive property (forward)',
            'The distributive property in reverse (factoring out a common factor)',
            'Combining like terms',
            'Properties of operations: commutative, associative, identity, inverse',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Solving Linear Equations',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'One-Step and Two-Step Equations',
          topics: [
            'What it means to solve an equation',
            'Inverse operations',
            'The balance/equality principle',
            'One-step equations (all four operations)',
            'Two-step equations',
            'Checking solutions',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Multi-Step Equations and Variables on Both Sides',
          topics: [
            'Multi-step equations requiring distribution',
            'Combining like terms within equations',
            'Equations with variables on both sides',
            'Special case: no solution (contradiction)',
            'Special case: infinite solutions (identity)',
            'Equations with fractions; clearing denominators using the LCD',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Special Equations and Inequalities',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Literal Equations, Absolute Value Equations, and Word Problems',
          topics: [
            'Literal equations (solving a formula for a specified variable)',
            'Absolute value equations of the form |ax + b| = c',
            'No-solution case for absolute value equations',
            'Word problems: distance, rate, and time',
            'Word problems: mixture',
            'Word problems: percent change',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Linear Inequalities: One-Variable, Compound, and Absolute Value',
          topics: [
            'Inequality symbols',
            'Graphing inequalities on a number line (open vs. closed circles)',
            'The flip-the-sign rule when multiplying or dividing by a negative',
            'Compound inequalities with "and" (intersection)',
            'Compound inequalities with "or" (union)',
            'Absolute value inequalities |x| < c and |x| > c',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Introduction to Functions',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Coordinate Plane, Relations, Functions, and Function Notation',
          topics: [
            'The coordinate plane and four quadrants',
            'Plotting points',
            'Relations as sets of ordered pairs',
            'Definition of a function',
            'The vertical line test',
            'Function notation f(x)',
            'Evaluating functions, including f(a + 1)-style inputs',
            'Domain and range from sets, graphs, and tables',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Slope and Rate of Change',
          topics: [
            'Slope as rise over run',
            'Slope as Δy/Δx',
            'Slope as rate of change',
            'Positive, negative, zero, and undefined slope',
            'Computing slope from two points',
            'Computing slope from a graph',
            'Computing slope from a table',
            'Slope as a unit rate in real-world contexts',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Linear Functions',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Slope-Intercept Form and Graphing Lines',
          topics: [
            'Slope-intercept form y = mx + b',
            'Identifying slope and y-intercept from an equation',
            'Graphing a line from slope-intercept form',
            'Writing the equation of a line from a graph',
            'Horizontal lines (y = k)',
            'Vertical lines (x = h) and why they are not functions',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Point-Slope Form, Standard Form, and Writing Linear Equations',
          topics: [
            'Point-slope form y − y₁ = m(x − x₁)',
            'Standard form Ax + By = C',
            'Converting between slope-intercept, point-slope, and standard form',
            'Finding x- and y-intercepts from standard form',
            'Writing the equation of a line given a slope and a point',
            'Writing the equation of a line given two points',
            'Writing the equation of a line from a graph',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Lines, Two-Variable Inequalities, and Systems',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Parallel and Perpendicular Lines; Linear Inequalities in Two Variables',
          topics: [
            'Parallel lines (equal slopes)',
            'Perpendicular lines (negative reciprocal slopes)',
            'Writing equations of lines parallel or perpendicular to a given line',
            'Linear inequalities in two variables',
            'Solid vs. dashed boundary lines',
            'Shading the correct half-plane',
            'The test-point method',
            'Linear inequalities in standard form',
            'Half-planes',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Solving Systems by Graphing and Substitution',
          topics: [
            'Definition of a system of equations and its solution',
            'Three solution cases: one solution, no solution, infinite solutions',
            'Solving a system by graphing',
            'Solving a system by substitution',
            'Choosing which variable to isolate',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Systems, Exponents, and Polynomials',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Elimination, Systems of Inequalities, and Applications',
          topics: [
            'Solving systems by elimination (basic cases)',
            'Elimination requiring multiplication of one or both equations',
            'Choosing between substitution and elimination',
            'Systems of inequalities (graphing the overlap)',
            'Application problems: number and age',
            'Application problems: mixture',
            'Application problems: money and coins',
            'Application problems: distance, rate, and time',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Properties of Exponents and Scientific Notation',
          topics: [
            'Product rule',
            'Quotient rule',
            'Power rule',
            'Power of a product',
            'Power of a quotient',
            'Zero exponent',
            'Negative exponents',
            'Simplifying expressions using multiple rules',
            'Converting between scientific notation and standard form',
            'Multiplying and dividing numbers in scientific notation',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Polynomials and Factoring',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Polynomials: Adding, Subtracting, and Multiplying',
          topics: [
            'Polynomial vocabulary: monomial, binomial, trinomial, polynomial',
            'Degree, standard form, and leading coefficient',
            'Adding polynomials',
            'Subtracting polynomials',
            'Multiplying a monomial by a polynomial',
            'Multiplying two binomials (FOIL and distributive property)',
            'Multiplying larger polynomials',
            'Special product: (a + b)²',
            'Special product: (a − b)²',
            'Special product: (a + b)(a − b)',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Factoring (Comprehensive)',
          topics: [
            'Factoring as the inverse of multiplying',
            'Factoring out the greatest common factor (GCF)',
            'Difference of squares: a² − b² = (a + b)(a − b)',
            'Factoring trinomials of the form x² + bx + c',
            'Factoring trinomials of the form ax² + bx + c (AC method or trial-and-error)',
            'Perfect square trinomials',
            'Factoring by grouping (four-term polynomials)',
            'The factoring decision tree (GCF first, then by term count)',
            'Checking factoring by re-multiplying',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Quadratic Functions and Equations',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Graphing Quadratics; Solving by Factoring and Square Roots',
          topics: [
            'Parts of a parabola: vertex, axis of symmetry, direction of opening',
            'Maximum and minimum values',
            'y-intercept and x-intercepts (zeros/roots) of a parabola',
            'Graphing y = ax² + bx + c using the vertex formula and a table',
            'Vertex form y = a(x − h)² + k',
            'The Zero Product Property',
            'Solving quadratic equations by factoring',
            'Solving quadratic equations by taking square roots',
            'The ± symbol when taking square roots of both sides',
            'Simplifying radicals (introduction, e.g., √50 = 5√2)',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Completing the Square, the Quadratic Formula, and the Discriminant',
          topics: [
            'Completing the square',
            'Derivation of the quadratic formula via completing the square',
            'Solving with the quadratic formula',
            'The discriminant b² − 4ac',
            'Number and type of solutions based on the discriminant',
            'Choosing a solution method (factoring, square roots, quadratic formula)',
            'The Pythagorean theorem (a² + b² = c²)',
            'The distance formula (introduction)',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Other Function Families and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Exponential Functions and Sequences',
          topics: [
            'Exponential functions y = a · bˣ',
            'Exponential growth (b > 1)',
            'Exponential decay (0 < b < 1)',
            'Graphing exponential functions',
            'y-intercept, horizontal asymptote, and end behavior of exponentials',
            'Compound interest applications',
            'Population growth and decay applications',
            'Arithmetic sequences and the explicit formula aₙ = a₁ + (n − 1)d',
            'Connection between arithmetic sequences and linear functions',
            'Geometric sequences and the explicit formula aₙ = a₁ · r^(n − 1)',
            'Connection between geometric sequences and exponential functions',
            'Comparing linear vs. exponential growth',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted review of high-leverage problem types',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const GEOMETRY_CURRICULUM = {
  overview: 'Shapes, proofs, theorems, and spatial reasoning.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Foundations of Geometry',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Points, Lines, Planes, and Angles',
          topics: [
            'Undefined terms (point, line, plane)',
            'Line segments and rays',
            'Distance and the midpoint formula',
            'Angle measurement and the protractor',
            'Acute, right, obtuse, straight, and reflex angles',
            'Angle bisectors',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Logic and Proof Introduction',
          topics: [
            'Inductive vs. deductive reasoning',
            'Conditional statements (if-then)',
            'Converse, inverse, and contrapositive',
            'Biconditional statements',
            'Counterexamples',
            'Introduction to two-column proofs',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Angle Relationships',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Angle Pairs',
          topics: [
            'Complementary angles',
            'Supplementary angles',
            'Vertical angles',
            'Adjacent angles',
            'Linear pairs',
            'Angle addition postulate',
            'Solving for unknown angles',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Parallel Lines and Transversals',
          topics: [
            'Corresponding angles',
            'Alternate interior angles',
            'Alternate exterior angles',
            'Co-interior (same-side interior) angles',
            'Proving lines parallel',
            'Solving for angles in parallel-line diagrams',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Triangles',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Triangle Properties',
          topics: [
            'Classifying triangles by sides (scalene, isosceles, equilateral)',
            'Classifying triangles by angles (acute, right, obtuse)',
            'Triangle angle sum (180°)',
            'Exterior angle theorem',
            'Triangle inequality theorem',
            'Isosceles triangle theorem',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Triangle Congruence',
          topics: [
            'Definition of congruence',
            'Congruent triangles and CPCTC',
            'SSS, SAS, ASA, AAS criteria',
            'HL for right triangles',
            'Why SSA does not work',
            'Writing congruence proofs',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Triangle Similarity',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Similar Triangles',
          topics: [
            'Definition of similarity',
            'Ratios and proportions in similar figures',
            'AA, SAS, and SSS similarity criteria',
            'Scale factor',
            'Side-splitter theorem',
            'Real-world similarity problems (shadows, indirect measurement)',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Right Triangles and the Pythagorean Theorem',
          topics: [
            'The Pythagorean theorem',
            'Pythagorean triples',
            'Converse of the Pythagorean theorem',
            'Special right triangles (45-45-90)',
            'Special right triangles (30-60-90)',
            'Applications of the Pythagorean theorem',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Quadrilaterals and Polygons',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Quadrilaterals',
          topics: [
            'Parallelograms and their properties',
            'Rectangles, rhombi, and squares',
            'Trapezoids and isosceles trapezoids',
            'Kites',
            'The hierarchy of quadrilaterals',
            'Proving quadrilateral types',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Polygons',
          topics: [
            'Regular and irregular polygons',
            'Interior angle sum: (n − 2) × 180°',
            'Exterior angle sum (always 360°)',
            'Finding individual interior and exterior angles in regular polygons',
            'Concave vs. convex polygons',
            'Diagonals of polygons',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Coordinate Geometry',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Distance, Midpoint, and Slope',
          topics: [
            'The distance formula',
            'The midpoint formula',
            'Slope of a line on the coordinate plane',
            'Parallel and perpendicular lines on the coordinate plane',
            'Equations of lines',
            'Equations of perpendicular bisectors',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Polygons on the Coordinate Plane',
          topics: [
            'Classifying triangles on the coordinate plane',
            'Classifying quadrilaterals on the coordinate plane',
            'Perimeter using the distance formula',
            'Area of polygons on a grid',
            'Transformations and coordinate notation',
            'Real-world coordinate geometry',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Circles',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Circle Basics',
          topics: [
            'Radius, diameter, chord, secant, and tangent',
            'Central angles and inscribed angles',
            'Arcs (minor, major, semicircle)',
            'Arc length',
            'Tangent line properties',
            'Tangent and chord relationships',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Circle Theorems and Equations',
          topics: [
            'Inscribed angle theorem',
            'Angles formed by chords, secants, and tangents',
            'Power of a point',
            'Standard form of a circle: (x − h)² + (y − k)² = r²',
            'Graphing circles',
            'Writing circle equations from given information',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Area and Perimeter',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Area of Polygons',
          topics: [
            "Area of triangles (including Heron's formula)",
            'Area of parallelograms',
            'Area of trapezoids',
            'Area of regular polygons (apothem formula)',
            'Area of composite figures',
            'Real-world area problems',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Circumference, Area, and Sectors of Circles',
          topics: [
            'Circumference of a circle',
            'Area of a circle',
            'Arc length',
            'Area of a sector',
            'Area of a segment',
            'Real-world circle problems',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Surface Area and Volume',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Surface Area',
          topics: [
            'Surface area of prisms',
            'Surface area of cylinders',
            'Surface area of pyramids',
            'Surface area of cones',
            'Surface area of spheres',
            'Composite solids',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Volume',
          topics: [
            'Volume of prisms',
            'Volume of cylinders',
            'Volume of pyramids',
            'Volume of cones',
            'Volume of spheres',
            'Volume of composite solids',
            'Cross sections',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Transformations and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Transformations and Symmetry',
          topics: [
            'Translations',
            'Reflections',
            'Rotations',
            'Dilations',
            'Composition of transformations',
            'Rigid motions and congruence',
            'Symmetry (line and rotational)',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key geometry concepts',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const ALGEBRA_2_CURRICULUM = {
  overview: 'Polynomials, exponentials, logarithms, and complex functions.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Foundations Review',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Real Numbers and Algebraic Expressions',
          topics: [
            'Properties of real numbers',
            'Operations on signed numbers',
            'Order of operations',
            'Simplifying algebraic expressions',
            'Distributive property and factoring out a GCF',
            'Evaluating expressions',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Linear and Absolute Value Equations and Inequalities',
          topics: [
            'Solving linear equations',
            'Solving literal equations',
            'Linear inequalities',
            'Compound inequalities (and / or)',
            'Absolute value equations',
            'Absolute value inequalities',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Linear Functions and Systems',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Linear Functions in Depth',
          topics: [
            'Slope-intercept, point-slope, and standard forms',
            'Parallel and perpendicular lines',
            'Writing equations of lines',
            'Graphing linear inequalities in two variables',
            'Linear models from data',
            'Piecewise functions (introduction)',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Systems of Equations and Inequalities',
          topics: [
            'Solving systems by graphing',
            'Solving systems by substitution',
            'Solving systems by elimination',
            'Systems of three variables',
            'Systems of linear inequalities',
            'Linear programming (introduction)',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Quadratic Functions',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Quadratics in Multiple Forms',
          topics: [
            'Standard form: y = ax² + bx + c',
            'Vertex form: y = a(x − h)² + k',
            'Factored form: y = a(x − r₁)(x − r₂)',
            'Converting between forms',
            'Identifying vertex, axis of symmetry, and intercepts',
            'Graphing quadratics',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Solving Quadratics and the Discriminant',
          topics: [
            'Solving by factoring',
            'Solving by square roots',
            'Completing the square',
            'The quadratic formula',
            'The discriminant and nature of solutions',
            'Complex solutions (introduction)',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Polynomial Functions',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Polynomial Operations',
          topics: [
            'Adding and subtracting polynomials',
            'Multiplying polynomials',
            'Special products (squares of binomials, difference of squares)',
            'Long division of polynomials',
            'Synthetic division',
            'The remainder theorem',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Factoring Polynomials',
          topics: [
            'Factoring out the GCF',
            'Factoring trinomials (a = 1 and a ≠ 1)',
            'Factoring by grouping',
            'Difference and sum of cubes',
            'Perfect square trinomials',
            'Combined factoring strategies',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Polynomial and Rational Functions',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Higher-Degree Polynomials',
          topics: [
            'End behavior of polynomial functions',
            'Zeros and multiplicities',
            'The rational root theorem',
            'Finding all zeros of a polynomial',
            'Graphing polynomial functions',
            'Polynomial inequalities',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Rational Expressions and Equations',
          topics: [
            'Simplifying rational expressions',
            'Multiplying and dividing rational expressions',
            'Adding and subtracting rational expressions',
            'Complex fractions',
            'Solving rational equations',
            'Extraneous solutions',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Radicals and Complex Numbers',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Radicals and Rational Exponents',
          topics: [
            'Simplifying radicals',
            'Rationalizing denominators',
            'Multiplying and dividing radicals',
            'Adding and subtracting radicals',
            'Rational exponents and their properties',
            'Converting between radical and exponential form',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Radical Equations and Complex Numbers',
          topics: [
            'Solving radical equations',
            'Extraneous solutions',
            'The imaginary unit i and its powers',
            'Complex numbers in a + bi form',
            'Operations on complex numbers',
            'Complex conjugates',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Exponential Functions',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Exponential Growth and Decay',
          topics: [
            'Exponential function form y = a · bˣ',
            'Identifying growth vs. decay',
            'Graphing exponential functions',
            'Domain, range, asymptotes, and end behavior',
            'Compound interest formula',
            'Real-world exponential models',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'The Number e and Continuous Growth',
          topics: [
            'The natural base e',
            'Continuous compound interest: A = Pe^(rt)',
            'Graphing y = eˣ',
            'Population and decay models with e',
            'Comparing models',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Logarithmic Functions',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Introduction to Logarithms',
          topics: [
            'Definition of a logarithm',
            'Converting between logarithmic and exponential forms',
            'Common logarithm (base 10)',
            'Natural logarithm (ln)',
            'Evaluating logarithms',
            'Graphing logarithmic functions',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Properties of Logarithms and Solving Equations',
          topics: [
            'Product, quotient, and power properties',
            'The change-of-base formula',
            'Expanding and condensing logarithmic expressions',
            'Solving exponential equations using logarithms',
            'Solving logarithmic equations',
            'Real-world applications (pH, decibels, earthquakes)',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Sequences, Series, and Probability',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Sequences and Series',
          topics: [
            'Arithmetic sequences and explicit formulas',
            'Arithmetic series and partial sums',
            'Geometric sequences and explicit formulas',
            'Geometric series and partial sums',
            'Infinite geometric series',
            'Sigma notation',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Counting and Probability',
          topics: [
            'Fundamental counting principle',
            'Permutations',
            'Combinations',
            'Probability of compound events',
            'Independent and dependent events',
            'Conditional probability',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Conic Sections and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Conic Sections Overview',
          topics: [
            'Circles in standard form',
            'Parabolas',
            'Ellipses',
            'Hyperbolas',
            'Identifying and graphing each type',
            'Real-world applications',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key Algebra 2 skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const PRE_CALCULUS_CURRICULUM = {
  overview: 'Trigonometry, advanced functions, and limits.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Functions and Their Properties',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Functions and Their Graphs',
          topics: [
            'Functions and function notation',
            'Domain and range',
            'Identifying functions (vertical line test)',
            'Increasing, decreasing, and constant intervals',
            'Even and odd functions',
            'Symmetry of graphs',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Combining and Transforming Functions',
          topics: [
            'Function operations (sum, difference, product, quotient)',
            'Composition of functions',
            'Vertical and horizontal shifts',
            'Vertical and horizontal stretches and compressions',
            'Reflections across axes',
            'Combining transformations',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Polynomial and Rational Functions',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'Polynomial Functions',
          topics: [
            'End behavior and leading coefficient',
            'Zeros and multiplicities',
            'The fundamental theorem of algebra',
            'Rational root theorem',
            "Descartes' rule of signs",
            'Graphing polynomial functions',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Rational Functions',
          topics: [
            'Vertical asymptotes',
            'Horizontal asymptotes',
            'Slant asymptotes',
            'Holes in the graph',
            'Graphing rational functions',
            'Solving rational inequalities',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Exponential and Logarithmic Functions',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Exponential Functions in Depth',
          topics: [
            'Properties of exponential functions',
            'Graphing exponentials and transformations',
            'The number e',
            'Compound interest (discrete and continuous)',
            'Exponential growth and decay models',
            'Logistic growth (introduction)',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Logarithmic Functions in Depth',
          topics: [
            'Definition and properties of logarithms',
            'Common and natural logarithms',
            'Change of base formula',
            'Solving exponential equations',
            'Solving logarithmic equations',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Trigonometry Foundations',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Right Triangle Trigonometry',
          topics: [
            'Sine, cosine, and tangent ratios',
            'Cosecant, secant, and cotangent',
            'Solving right triangles',
            'Angles of elevation and depression',
            'Special right triangle ratios (30-60-90, 45-45-90)',
            'Real-world right triangle problems',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Angles and the Unit Circle',
          topics: [
            'Degree and radian measure',
            'Converting between degrees and radians',
            'Arc length and sector area',
            'Coterminal angles',
            'Reference angles',
            'The unit circle and exact values',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Trigonometric Functions',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Graphing Trig Functions',
          topics: [
            'Graphs of sine and cosine',
            'Amplitude, period, phase shift, and vertical shift',
            'Graphs of tangent and cotangent',
            'Graphs of secant and cosecant',
            'Modeling periodic phenomena',
            'Real-world sinusoidal models',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Inverse Trig Functions',
          topics: [
            'Restricting domains for inverse functions',
            'Inverse sine, cosine, and tangent',
            'Evaluating inverse trig functions',
            'Composition of trig and inverse trig functions',
            'Solving simple trig equations',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Trig Identities and Equations',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Trigonometric Identities',
          topics: [
            'Reciprocal, quotient, and Pythagorean identities',
            'Even-odd identities',
            'Cofunction identities',
            'Sum and difference formulas',
            'Double-angle and half-angle formulas',
            'Verifying identities',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'Trigonometric Equations',
          topics: [
            'Solving basic trig equations',
            'Solving trig equations using identities',
            'Equations with multiple angles',
            'Equations involving quadratic patterns',
            'General solutions vs. solutions on an interval',
            'Real-world trig applications',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Triangles, Vectors, and Complex Numbers',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Law of Sines and Law of Cosines',
          topics: [
            'The law of sines',
            'The ambiguous case (SSA)',
            'The law of cosines',
            'Choosing between the two laws',
            "Area of a triangle: Heron's formula and trig formula",
            'Real-world triangle problems',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Vectors and Polar Form',
          topics: [
            'Vectors in the plane',
            'Component form and magnitude',
            'Vector addition, subtraction, and scalar multiplication',
            'Dot product and the angle between vectors',
            'Polar coordinates',
            'Complex numbers in polar form',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'Conic Sections',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Parabolas and Circles',
          topics: [
            'Definition of a parabola',
            'Standard and general form of parabolas',
            'Focus, directrix, and vertex',
            'Standard form of a circle',
            'Translating conics',
            'Real-world applications',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Ellipses and Hyperbolas',
          topics: [
            'Definition of an ellipse',
            'Standard form of an ellipse',
            'Foci, vertices, and eccentricity',
            'Definition of a hyperbola',
            'Standard form of a hyperbola',
            'Asymptotes of hyperbolas',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Sequences, Series, and the Binomial Theorem',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Sequences and Series',
          topics: [
            'Explicit and recursive formulas',
            'Arithmetic and geometric sequences',
            'Partial sums of arithmetic series',
            'Partial sums of geometric series',
            'Infinite geometric series and convergence',
            'Sigma notation',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Counting, Binomial Theorem, and Probability',
          topics: [
            'Permutations and combinations',
            "Pascal's triangle",
            'The binomial theorem',
            'Expanding binomials',
            'Binomial coefficients',
            'Probability with combinatorics',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Limits and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Introduction to Limits',
          topics: [
            'Intuitive notion of a limit',
            'Estimating limits from graphs and tables',
            'One-sided limits',
            'Limits at infinity',
            'Continuity',
            'The role of limits in calculus',
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key pre-calculus skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

const CALCULUS_CURRICULUM = {
  overview: 'Derivatives, integrals, and applications.',
  formatNote: '20 classes · 2 classes per week · 2 hours per class (45 min teaching + 15 min break + 60 min practice)',
  sections: [
    {
      id: 'week-1',
      label: 'Week 1',
      title: 'Limits and Continuity',
      lessons: [
        {
          id: 'class-1',
          label: 'Class 1',
          title: 'Understanding Limits',
          topics: [
            'Intuitive notion of a limit',
            'One-sided and two-sided limits',
            'Estimating limits from graphs and tables',
            'Computing limits algebraically',
            'Limit laws (sum, product, quotient)',
            'Limits of polynomial and rational functions',
          ],
        },
        {
          id: 'class-2',
          label: 'Class 2',
          title: 'Continuity and Limits at Infinity',
          topics: [
            'Definition of continuity at a point',
            'Continuity over an interval',
            'Discontinuities (removable, jump, infinite)',
            'The intermediate value theorem',
            'Limits at infinity and end behavior',
            'Horizontal and vertical asymptotes',
          ],
        },
      ],
    },
    {
      id: 'week-2',
      label: 'Week 2',
      title: 'Derivatives Introduction',
      lessons: [
        {
          id: 'class-3',
          label: 'Class 3',
          title: 'The Derivative',
          topics: [
            'Average rate of change',
            'Instantaneous rate of change',
            'The limit definition of the derivative',
            'Derivative notation (Leibniz, prime, dot)',
            'Slope of the tangent line',
            'Differentiability and continuity',
          ],
        },
        {
          id: 'class-4',
          label: 'Class 4',
          title: 'Basic Differentiation Rules',
          topics: [
            'Constant rule',
            'Power rule',
            'Constant multiple rule',
            'Sum and difference rules',
            'Derivatives of polynomials',
            'Higher-order derivatives',
          ],
        },
      ],
    },
    {
      id: 'week-3',
      label: 'Week 3',
      title: 'Derivative Rules',
      lessons: [
        {
          id: 'class-5',
          label: 'Class 5',
          title: 'Product and Quotient Rules',
          topics: [
            'The product rule',
            'The quotient rule',
            'Combining rules',
            'Derivatives involving radicals',
            'Derivatives involving negative exponents',
            'Common mistakes',
          ],
        },
        {
          id: 'class-6',
          label: 'Class 6',
          title: 'Chain Rule and Implicit Differentiation',
          topics: [
            'The chain rule',
            'Differentiating composite functions',
            'Multiple chain rule applications',
            'Implicit differentiation',
            'Derivatives of inverse functions',
            'Logarithmic differentiation',
          ],
        },
      ],
    },
    {
      id: 'week-4',
      label: 'Week 4',
      title: 'Derivatives of Special Functions',
      lessons: [
        {
          id: 'class-7',
          label: 'Class 7',
          title: 'Trigonometric Derivatives',
          topics: [
            'Derivatives of sine and cosine',
            'Derivatives of tangent, cotangent, secant, and cosecant',
            'Combining trig derivatives with other rules',
            'Derivatives of inverse trig functions',
            'Real-world trig differentiation',
            'Common patterns',
          ],
        },
        {
          id: 'class-8',
          label: 'Class 8',
          title: 'Exponential and Logarithmic Derivatives',
          topics: [
            'Derivative of eˣ',
            'Derivative of aˣ',
            'Derivative of ln(x)',
            'Derivative of log_a(x)',
            'Combining with other rules',
            'Logarithmic differentiation revisited',
          ],
        },
      ],
    },
    {
      id: 'week-5',
      label: 'Week 5',
      title: 'Applications of Derivatives',
      lessons: [
        {
          id: 'class-9',
          label: 'Class 9',
          title: 'Rates of Change and Linear Approximation',
          topics: [
            'Velocity, acceleration, and motion',
            'Position, velocity, and acceleration relationships',
            'Related rates problems',
            'Linear approximation (linearization)',
            'Differentials',
            'Real-world rate-of-change applications',
          ],
        },
        {
          id: 'class-10',
          label: 'Class 10',
          title: 'Curve Analysis',
          topics: [
            'Increasing and decreasing intervals',
            'Local maxima and minima (first derivative test)',
            'Concavity and inflection points',
            'Second derivative test',
            'Sketching graphs from derivatives',
            'The mean value theorem',
          ],
        },
      ],
    },
    {
      id: 'week-6',
      label: 'Week 6',
      title: 'Optimization and Related Rates',
      lessons: [
        {
          id: 'class-11',
          label: 'Class 11',
          title: 'Optimization',
          topics: [
            'Identifying the function to optimize',
            'Constraints and substitution',
            'Absolute maxima and minima on closed intervals',
            'Maximizing area, volume, and profit',
            'Minimizing cost, distance, and surface area',
            'Real-world optimization problems',
          ],
        },
        {
          id: 'class-12',
          label: 'Class 12',
          title: 'More Related Rates',
          topics: [
            'Setting up related rates equations',
            'Implicit differentiation in related rates',
            'Common related-rate scenarios (cones, ladders, shadows)',
            'Choosing variables and known quantities',
            'Multi-step related rates problems',
            'Real-world applications',
          ],
        },
      ],
    },
    {
      id: 'week-7',
      label: 'Week 7',
      title: 'Integration Introduction',
      lessons: [
        {
          id: 'class-13',
          label: 'Class 13',
          title: 'Antiderivatives and Indefinite Integrals',
          topics: [
            'The antiderivative',
            'The indefinite integral and + C',
            'Basic integration rules (power, constant)',
            'Integrating polynomials',
            'Integrating trig functions',
            'Integrating exponentials and 1/x',
          ],
        },
        {
          id: 'class-14',
          label: 'Class 14',
          title: 'Riemann Sums and the Definite Integral',
          topics: [
            'Approximating area under a curve',
            'Left, right, and midpoint Riemann sums',
            'The trapezoidal rule',
            'The definite integral as a limit of Riemann sums',
            'Properties of definite integrals',
            'The geometric meaning of negative integrals',
          ],
        },
      ],
    },
    {
      id: 'week-8',
      label: 'Week 8',
      title: 'The Fundamental Theorem',
      lessons: [
        {
          id: 'class-15',
          label: 'Class 15',
          title: 'Fundamental Theorem of Calculus',
          topics: [
            'Part 1: derivative of an integral',
            'Part 2: evaluating definite integrals',
            'Connecting differentiation and integration',
            'Computing definite integrals algebraically',
            'Applications to net change',
            'Average value of a function',
          ],
        },
        {
          id: 'class-16',
          label: 'Class 16',
          title: 'Integration Techniques',
          topics: [
            'U-substitution for indefinite integrals',
            'U-substitution for definite integrals',
            'Substitution with trig and exponential functions',
            'Recognizing patterns for substitution',
            'Multi-step substitutions',
            'Common mistakes',
          ],
        },
      ],
    },
    {
      id: 'week-9',
      label: 'Week 9',
      title: 'Applications of Integration',
      lessons: [
        {
          id: 'class-17',
          label: 'Class 17',
          title: 'Area Between Curves',
          topics: [
            'Area between two curves with respect to x',
            'Area between two curves with respect to y',
            'Identifying intersection points',
            'Splitting integrals over intervals',
            'Real-world area applications',
            'Average value as area divided by interval length',
          ],
        },
        {
          id: 'class-18',
          label: 'Class 18',
          title: 'Volumes and More',
          topics: [
            'Volume by disks',
            'Volume by washers',
            'Volume by cylindrical shells (introduction)',
            'Volumes by cross sections',
            'Arc length (introduction)',
            'Real-world volume applications',
          ],
        },
      ],
    },
    {
      id: 'week-10',
      label: 'Week 10',
      title: 'Differential Equations and Comprehensive Review',
      lessons: [
        {
          id: 'class-19',
          label: 'Class 19',
          title: 'Introduction to Differential Equations',
          topics: [
            'What is a differential equation',
            'Verifying solutions',
            'Separable differential equations',
            'Initial value problems',
            'Exponential growth and decay models',
            "Newton's law of cooling",
          ],
        },
        {
          id: 'class-20',
          label: 'Class 20',
          title: 'Comprehensive Review and Final Assessment',
          topics: [
            'Cumulative review across all 19 prior topic groups',
            'Targeted practice on key calculus skills',
            'Cumulative final assessment',
          ],
        },
      ],
    },
  ],
};

export const CURRICULA = {
  'math-foundations-1': MATH_FOUNDATIONS_1_CURRICULUM,
  'math-foundations-2': MATH_FOUNDATIONS_2_CURRICULUM,
  'math-foundations-3': MATH_FOUNDATIONS_3_CURRICULUM,
  'math-foundations-4': MATH_FOUNDATIONS_4_CURRICULUM,
  'arithmetic-mastery': ARITHMETIC_MASTERY_CURRICULUM,
  'intro-pre-algebra': INTRO_PRE_ALGEBRA_CURRICULUM,
  'pre-algebra': PRE_ALGEBRA_CURRICULUM,
  'algebra-1': ALGEBRA_1_CURRICULUM,
  'geometry': GEOMETRY_CURRICULUM,
  'algebra-2': ALGEBRA_2_CURRICULUM,
  'pre-calculus': PRE_CALCULUS_CURRICULUM,
  'calculus': CALCULUS_CURRICULUM,
};

export function getCurriculumByCourseId(courseId) {
  return CURRICULA[courseId] ?? null;
}